import Field from './Field';

export default class Area {
    static fromData(data) {
        if (!data) {
            return;
        }

        let area = new Area();

        area.id = data.id || null;
        area.name = data.name;
        area.note = data.note;
        area.size = data.size;
        area.maxPersons = data.maxPersons;
        area.fields = data.fields.data.map(data => Field.fromData(data));
        area.hasImage = data.hasImage;
        area.imageUrl = data.imageUrl;
        area.hierarchyPath = data.hierarchyPath;
        area.isArchived = data.isArchived;
        area.isViewable = data.isViewable;
        area.isEditable = data.isEditable;
        area.isDeletable = data.isDeletable;
        area.locationId = data.locationId;

        Object.seal(area);
        return area;
    }

    equals(area){
        if (area.id === null) {
            return false;
        }
        return area.id === this.id;
    }
}
